/**
 * ****************************************************************************
 * @description     :   Combinie all reducers on app
 * @created at      :   2020/12/03
 * @created by      :   QuyPN - quy.pham@toploop.co
 * @package         :   dashlite-admin-react
 * @copyright       :   Copyright (c) TOPLOOP
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import libraries
 */
import { combineReducers } from 'redux'
import appReducer from './app/reducer'
import dashboardReducer from './dashboard/reducer'
import holonReducer from './holon/reducer'
import userReducer from './user/reducer'
import policySettingReducer from './policy-setting/reducer'
import termOfUseReducer from './term-of-use/reducer'
import privacyPolicyReducer from './privacy-policy/reducer'
import privatePolicyReducer from './private-policy/reducer'
import faqReducer from './faq/reducer'
import holonTemplateReducer from './holon-template/reducer'
import menuManagementReducer from './menu-management/reducer'
import messageReducer from './message/reducer'
import holonInstanceReducer from './holon-instance/reducer'
import alarmHolonTemplateReducer from './alarm-holon-setting/reducer'
import hexServiceReducer from './hex-service/reducer'
import blInstanceReducer from './bl-instance/reducer'
import alarmReducer from './alarm/reducer'
import homeReducer from './home/reducer'
import inquiryReducer from './inquiry/reducer'
import wareHouseReducer from './warehouse/reducer'
import productReducer from './product/reducer'
import senderReducer from './sender/reducer'
import receiverReducer from './receiver/reducer'
import addressReducer from './address/reducer'
import stocksReducer from './stocks/reducer'
import walletReducer from './wallet/reducer'
import cargoReducer from './cargo/reducer'
import warehouseInReducer from './warehouse-in/reducer'
import fareCalculationReducer from './freight-calculation/reducer'
import transactionReducer from './transaction/reducer'
import orderReducer from './order/reducer'
import systemSettingReducer from './system-setting/reducer'

/**
 * import reducer process for all child components
 */

/**
 * Combinie all reducers on app
 * -----------------------------------------
 * @author : QuyPN - 2020/12/03 - create
 * @access : public
 */
const rootReducer = combineReducers({
    app: appReducer, 
    dashboard: dashboardReducer,
    holon: holonReducer,
    user: userReducer,
    policySetting: policySettingReducer,
    termOfUse: termOfUseReducer,
    privacyPolicy: privacyPolicyReducer,
    privatePolicy: privatePolicyReducer,
    faq: faqReducer,
    holonTemplate: holonTemplateReducer,
    menuManagement: menuManagementReducer,
    message: messageReducer,
    holonInstance: holonInstanceReducer,
    alarmHolonTemplate: alarmHolonTemplateReducer,
    hexService: hexServiceReducer,
    blInstance: blInstanceReducer,
    alarm: alarmReducer,
    home: homeReducer,
    inquiry: inquiryReducer,
    product: productReducer,
    warehouse: wareHouseReducer,
    sender: senderReducer,
    receiver: receiverReducer,
    address: addressReducer,
    stocks: stocksReducer,
    wallet: walletReducer,
    cargo: cargoReducer,
    warehouseIn: warehouseInReducer,
    fareCalculation: fareCalculationReducer,
    transaction: transactionReducer,
    order: orderReducer,
    systemSetting: systemSettingReducer
})

export default rootReducer
